'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import clsx from 'clsx';
import { forwardRef, useMemo } from 'react';
import styles from './scroll-area.module.css';
export const ScrollArea = forwardRef(({ as: Component = 'div', children, className, canScroll = true, thumbColor, trackColor, bleed, useSystemStyle = true, hideScrollbars = false, gutterBehavior = 'auto', fadeDirection, overscrollBehavior = 'contain', fadeSize = 16, style, ...otherProps }, forwardedRef) => {
    const computedFadeDirection = useMemo(() => {
        if (fadeSize) {
            return typeof fadeSize === 'string' ? fadeSize : tkns.space[fadeSize];
        }
        return '0';
    }, [fadeSize]);
    const dynamicStyle = useMemo(() => ({
        '--thumb-color': thumbColor,
        '--track-color': trackColor,
        '--gutter-behaviour': gutterBehavior,
        '--fade-size': computedFadeDirection,
        '--overscroll-behavior': overscrollBehavior,
        '--bleed': bleed ? tkns.space[bleed] : 0,
    }), [thumbColor, trackColor, gutterBehavior, overscrollBehavior, bleed, computedFadeDirection]);
    return (_jsx(Component, { ref: forwardedRef, className: clsx(styles.ScrollArea, className), "data-scroll-area-scrolling": canScroll, "data-scroll-visible": !hideScrollbars, "data-scroll-use-system": useSystemStyle, "data-scroll-fade-direction": fadeDirection, style: { ...dynamicStyle, ...style }, ...otherProps, children: children }));
});
